import React from 'react';
import PropTypes from 'prop-types';
import s from './SidebarSectionTitle.module.css';

const SectionTitle = ({ title, className, disabled, index, labelFor }) => {
  const titleClassName = `${s.title} ${disabled ? s.disabled : ''} ${className}`;

  return (
    <div>
      <h4
        className={`returns-sidebar-section-title returns-sidebar-section-title-${index} ${titleClassName}`}
        aria-level={2}
      >
        {labelFor ? (
          // eslint-disable-next-line jsx-a11y/label-has-for
          <label
            htmlFor={labelFor}
            style={{ margin: 0, fontWeight: 'inherit', display: 'inherit', maxWidth: 'inherit' }}
          >
            {title}
          </label>
        ) : (
          title
        )}
      </h4>
    </div>
  );
};

SectionTitle.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  index: PropTypes.number,
  labelFor: PropTypes.string,
};

SectionTitle.defaultProps = {
  className: '',
  disabled: false,
  index: 0,
  labelFor: '',
};

export default SectionTitle;
